var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoTreeCreated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-duplicate",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes slideLeft{0%{opacity:0;transform:translateX(-30px)}to{opacity:1;transform:translateX(0)}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}@keyframes shake{10%,90%{transform:translate3d(-1px,0,0)}20%,80%{transform:translate3d(2px,0,0)}30%,50%,70%{transform:translate3d(-4px,0,0)}40%,60%{transform:translate3d(4px,0,0)}}svg#freepik_stories-duplicate:not(.animated) .animable{opacity:0}svg#freepik_stories-duplicate.animated #freepik--speech-bubble--inject-49{animation:1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn;animation-delay:0s}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-49",
    className: "animable",
    style: {
      transformOrigin: "247px 344.3px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-49",
    cx: 247,
    cy: 344.3,
    rx: 234.59,
    ry: 140.4,
    style: {
      fill: "#f5f5f5",
      transformOrigin: "247px 344.3px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-49",
    className: "animable",
    style: {
      transformOrigin: "259.934px 364.509px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-49",
    d: "m288.54 281.75-4.25-2.45a11.48 11.48 0 0 0-10.43 0L49.47 408.85c-2.87 1.66-2.87 4.37 0 6l4.24 2.45a11.54 11.54 0 0 0 10.43 0l68.17-39.3 30.33 17.51c7.82 4.51 20.61 4.51 28.43 0l47-27.15c6.68-3.86 6.68-10.17 0-14L205.7 335.6l82.84-47.83c2.87-1.66 2.87-4.37 0-6.02Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "169.005px 348.296px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-49",
    d: "M370.2 440.83c23.42 13.52 61.38 13.52 84.79 0s23.42-35.43 0-48.95-61.37-13.52-84.79 0-23.41 35.43 0 48.95Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "412.595px 416.355px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-49",
    className: "animable",
    style: {
      transformOrigin: "117.38px 87.8301px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-49",
    className: "animable",
    style: {
      transformOrigin: "117.38px 87.8301px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m140.82 86.46 3.77-2.28a6.56 6.56 0 0 1-.05-.79v-1.86a11.5 11.5 0 0 1 5.2-9 4.08 4.08 0 0 1 3.1-.6c.47-4.71 3.74-10 7.72-12.34 4.29-2.48 7.78-.47 7.78 4.49v2.79a13.49 13.49 0 0 1-.66 4l5.32-3.1c1.6-.92 2.89-.18 2.89 1.66a6.37 6.37 0 0 1-2.89 5l-32.2 18.69c-1.59.92-2.88.18-2.88-1.66a6.39 6.39 0 0 1 2.9-5Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "156.905px 76.0215px"
    },
    id: "el9hwlyn0hc8f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.54 78.86-4 1.52v-8.7c0-6.9-5.5-8.55-11.48-5.11C87.14 70 82.3 78.41 82.3 85.31v1.26a5.79 5.79 0 0 0-5 .78 17.18 17.18 0 0 0-7.78 13.48v.57L64 104.58a11.33 11.33 0 0 0-5.13 8.88c0 3.27 2.3 4.59 5.13 3l44.54-25.76a11.34 11.34 0 0 0 5.12-8.88c0-3.27-2.29-4.6-5.12-2.96Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "86.265px 90.9825px"
    },
    id: "el875trdltjzh",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-49",
    className: "animable",
    style: {
      transformOrigin: "168.475px 216.143px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-49",
    className: "animable",
    style: {
      transformOrigin: "168.475px 216.143px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m191.61 388.5 38.91-22.5c4-2.32 6-5.35 6-8.38v-5.42l-36.61-20.77a8.57 8.57 0 0 1-3.87-6.71v-48L128.12 316v48a8.55 8.55 0 0 0 3.88 6.7l30.58 17.8c8.01 4.63 21.01 4.63 29.03 0Z",
    style: {
      fill: "#263238",
      transformOrigin: "182.32px 334.346px"
    },
    id: "eldz0gw0ezivg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.43 372.49v5.39L132 370.7a8.56 8.56 0 0 1-3.87-6.71V316l12.95-7.47c.26 3.29.56 6.69.82 10l-9.07 5.25v37.48a8.51 8.51 0 0 0 3.86 6.7Z",
    style: {
      opacity: 0.15,
      transformOrigin: "136.28px 343.205px"
    },
    className: "animable",
    id: "elm83hh9t7u3r"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8 361.29a8.56 8.56 0 0 0 3.88 6.71l25.88 15.09c8 4.64 21 4.64 29.05 0l38.92-22.49c8-4.63 8-12.14 0-16.77l-25.91-15.11a8.53 8.53 0 0 1-3.87-6.7v-37.47l-68 39.26Z",
    style: {
      fill: "#455a64",
      transformOrigin: "184.64px 335.56px"
    },
    id: "elyt9abxacpb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.52 333.29-7.89-4.56a8.53 8.53 0 0 1-3.87-6.7v-37.48l-68 39.26v37.48a8.56 8.56 0 0 0 3.88 6.71l7.75 4.48Z",
    style: {
      opacity: 0.3,
      transformOrigin: "172.64px 328.515px"
    },
    className: "animable",
    id: "elujbygo2d9z9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.86 390.87a10.38 10.38 0 0 0 9.38-.17l223.57-129.08a10.68 10.68 0 0 0 4.83-8.38V49.56a10.35 10.35 0 0 0-4.54-8.21 10.38 10.38 0 0 0-9.38.17L52.16 170.59a10.72 10.72 0 0 0-4.84 8.41v203.66a10.37 10.37 0 0 0 4.54 8.21Z",
    style: {
      fill: "#455a64",
      transformOrigin: "168.48px 216.11px"
    },
    id: "eltjniki41lbg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.24 390.69 223.57-129.07a10.72 10.72 0 0 0 4.84-8.39V49.55c0-3.09-2.17-4.34-4.84-2.79L61.24 175.83a10.71 10.71 0 0 0-4.84 8.38V387.9c0 3.1 2.17 4.33 4.84 2.79Z",
    style: {
      fill: "#37474f",
      transformOrigin: "173.025px 218.724px"
    },
    id: "elew18ew84mde",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8 356.11V186.37a6.54 6.54 0 0 1 3-5.15L280.26 57.38c1.65-1 3-.18 3 1.72v169.74a6.57 6.57 0 0 1-3 5.16L65.77 357.83c-1.64.95-2.97.17-2.97-1.72Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "173.03px 207.593px"
    },
    id: "eljzcvjpqc86r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8 356.11V186.37a6.54 6.54 0 0 1 3-5.15L280.26 57.38c1.65-1 3-.18 3 1.72v169.74a6.57 6.57 0 0 1-3 5.16L65.77 357.83c-1.64.95-2.97.17-2.97-1.72Z",
    style: {
      fill: "#fff",
      opacity: 0.7,
      transformOrigin: "173.03px 207.593px"
    },
    className: "animable",
    id: "eleh45124z5sp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.75 174.19 9.07 5.23a10.42 10.42 0 0 0-1.43 4.79V387.9c0 2.81 1.91 4.39 4.84 2.8a10.29 10.29 0 0 1-9.38.17 9.31 9.31 0 0 1-4.55-7.63V179a9.94 9.94 0 0 1 1.45-4.81Z",
    style: {
      fill: "#263238",
      transformOrigin: "54.265px 283.054px"
    },
    id: "elf76mjdmg1m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.78 315.74 10.95-6.29c1-.56 1.78-.16 1.78.9a3.83 3.83 0 0 1-1.78 2.95l-10.95 6.28c-1 .57-1.77.17-1.77-.9a3.78 3.78 0 0 1 1.77-2.94Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "174.26px 314.518px"
    },
    id: "el1yfmrekjbju",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-49",
    className: "animable",
    style: {
      transformOrigin: "103.934px 392.68px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-49",
    className: "animable",
    style: {
      transformOrigin: "103.934px 392.68px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m114.91 422.79 7.63-4.41s4.55-18.89 2.74-35.89C122.73 358.6 107 349.61 101 351.67s-7.71 9 2.18 23.25c5.82 8.39 13.04 25.88 11.73 47.87Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "110.918px 387.088px"
    },
    id: "el3hxvl3qav8b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "110.918px 387.088px"
    },
    className: "animable",
    id: "elwh3fw2g4uz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m114.91 422.79 7.63-4.41s4.55-18.89 2.74-35.89C122.73 358.6 107 349.61 101 351.67s-7.71 9 2.18 23.25c5.82 8.39 13.04 25.88 11.73 47.87Z",
    style: {
      fill: "#fff",
      transformOrigin: "110.918px 387.088px"
    },
    id: "elkejhsbwbpzr",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.07 413.51H118a.52.52 0 0 1-.42-.62c4.18-22-3.52-46.8-13-57.11a.51.51 0 0 1 0-.74.53.53 0 0 1 .75 0c9.71 10.49 17.55 35.66 13.31 58a.54.54 0 0 1-.57.47Z",
    style: {
      fill: "#fff",
      transformOrigin: "112.12px 384.198px"
    },
    id: "elvl8jg7fkfd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.68 433.89c-1.14.58-4.17-2-5-2.65a10.61 10.61 0 0 1-3.33-4.24 9.87 9.87 0 0 1-.58-6 22.85 22.85 0 0 1 .91-3.13l1-3a7.79 7.79 0 0 0 .61-3.07c-.17-2.12-2-3.69-3.59-5-1.81-1.5-3.67-3.46-3.53-6a8.91 8.91 0 0 1 2.5-5.18c1.29-1.47 2.79-2.76 4-4.32a6.23 6.23 0 0 0 1.47-3.87 6.73 6.73 0 0 0-.73-2.5 34.1 34.1 0 0 1-2.41-5.1c-.53-1.8-.33-4 1.11-5.2a5.81 5.81 0 0 1 4.41-.86 9.83 9.83 0 0 1 4 1.63c3.91 2.44 6 7.31 10.14 9.24a42.05 42.05 0 0 0 5.09 1.53 6.34 6.34 0 0 1 4.11 3.13c1.41 3.2-1.69 6.91-.75 10.28.82 3 3.62 4.25 5.09 7a6.31 6.31 0 0 1 .55 3.88 18.15 18.15 0 0 1-1.95 6.42 58.37 58.37 0 0 1-3.85 5.93s-19.09 10.99-19.27 11.08Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "101.504px 403.812px"
    },
    id: "elz3hjdqd8l1l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "101.504px 403.812px"
    },
    className: "animable",
    id: "elyevihgelbne"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.68 433.89c-1.14.58-4.17-2-5-2.65a10.61 10.61 0 0 1-3.33-4.24 9.87 9.87 0 0 1-.58-6 22.85 22.85 0 0 1 .91-3.13l1-3a7.79 7.79 0 0 0 .61-3.07c-.17-2.12-2-3.69-3.59-5-1.81-1.5-3.67-3.46-3.53-6a8.91 8.91 0 0 1 2.5-5.18c1.29-1.47 2.79-2.76 4-4.32a6.23 6.23 0 0 0 1.47-3.87 6.73 6.73 0 0 0-.73-2.5 34.1 34.1 0 0 1-2.41-5.1c-.53-1.8-.33-4 1.11-5.2a5.81 5.81 0 0 1 4.41-.86 9.83 9.83 0 0 1 4 1.63c3.91 2.44 6 7.31 10.14 9.24a42.05 42.05 0 0 0 5.09 1.53 6.34 6.34 0 0 1 4.11 3.13c1.41 3.2-1.69 6.91-.75 10.28.82 3 3.62 4.25 5.09 7a6.31 6.31 0 0 1 .55 3.88 18.15 18.15 0 0 1-1.95 6.42 58.37 58.37 0 0 1-3.85 5.93s-19.09 10.99-19.27 11.08Z",
    style: {
      fill: "#fff",
      transformOrigin: "101.504px 403.812px"
    },
    id: "el55ki31pm7mv",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.74 428.13a.5.5 0 0 1-.46-.55c1.82-19.82-6.43-42.22-12.91-48.94a.5.5 0 0 1 0-.71.51.51 0 0 1 .71 0c6.61 6.85 15 29.63 13.18 49.73a.5.5 0 0 1-.52.47Z",
    style: {
      fill: "#fff",
      transformOrigin: "100.367px 402.958px"
    },
    id: "el9875wccq4ih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.77 403.68a.4.4 0 0 1-.15 0 67.84 67.84 0 0 0-14.29-3 .5.5 0 0 1-.46-.54.49.49 0 0 1 .55-.45 67.69 67.69 0 0 1 14.55 3.1.52.52 0 0 1 .3.65.49.49 0 0 1-.5.24Z",
    style: {
      fill: "#fff",
      transformOrigin: "97.5829px 401.687px"
    },
    id: "elzw01h3qc4di",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-49",
    className: "animable",
    style: {
      transformOrigin: "263.58px 210.32px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-49",
    className: "animable",
    style: {
      transformOrigin: "263.58px 210.32px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "263.58px 210.32px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.06 54.43a2.43 2.43 0 0 0-.1-.55.13.13 0 0 0 0-.12 2.17 2.17 0 0 0-.14-.53 2.75 2.75 0 0 0-.35-.76 1 1 0 0 0-.2-.31.92.92 0 0 0-.17-.22 2.4 2.4 0 0 0-.39-.39 2.9 2.9 0 0 0-.51-.29 4.32 4.32 0 0 0-4 .51L165.64 169.22c-3.29 1.89-6 6.53-6 13.17v187.53a4.09 4.09 0 0 0 6.15 3.54L369.13 256a13.21 13.21 0 0 0 6-10.34V55.17c-.04-.25-.05-.51-.07-.74Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "267.385px 212.501px"
    },
    id: "el1nq3n5z2d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.77 51.89a2.19 2.19 0 0 1 1 .21 1.17 1.17 0 0 1 .27.15h.06a1.26 1.26 0 0 1 .2.2l.08.11.07.1.05.06v.08l.07.11a1.67 1.67 0 0 1 .22.49 1.42 1.42 0 0 1 .05.16v.08l.12.38a1.67 1.67 0 0 1 .06.32v191.29a12.29 12.29 0 0 1-5.49 9.5l-203.3 117.5a3 3 0 0 1-1.57.43 3.15 3.15 0 0 1-3.14-3.14V182.39c0-6.76 2.84-10.81 5.49-12.34L369.6 52.56a4.46 4.46 0 0 1 2.17-.67m0-1a5.33 5.33 0 0 0-2.64.81L165.64 169.22c-3.29 1.89-6 6.53-6 13.17v187.53a4.1 4.1 0 0 0 4.1 4.1 4 4 0 0 0 2-.56L369.13 256a13.21 13.21 0 0 0 6-10.34V54.43a2.43 2.43 0 0 0-.1-.55.13.13 0 0 0 0-.12 2.17 2.17 0 0 0-.14-.53 2.75 2.75 0 0 0-.35-.76 1 1 0 0 0-.2-.31.92.92 0 0 0-.17-.22 2.4 2.4 0 0 0-.39-.39 2.9 2.9 0 0 0-.51-.29 3.09 3.09 0 0 0-1.37-.3Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "267.385px 212.455px"
    },
    id: "el4krcst0f1f8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.48 165.48 135.76-78.39v6.3l-135.76 78.38c-1.28.74-2.32.13-2.32-1.34v-.93a5.09 5.09 0 0 1 2.32-4.02Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "285.2px 129.588px"
    },
    id: "elkdgh9gdwlk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.14 80.8-8.22 4.74v6.3l8.22-4.75a5.13 5.13 0 0 0 2.32-4v-.93c0-1.5-1.04-2.1-2.32-1.36Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "362.19px 86.1618px"
    },
    id: "elg518gsiju2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.14 87.8a.84.84 0 0 1-.46-.13 1.41 1.41 0 0 1-.58-1.29 3.45 3.45 0 0 1 1.45-2.76 1.11 1.11 0 0 1 1.12-.07 1.43 1.43 0 0 1 .58 1.29 3.42 3.42 0 0 1-1.45 2.76 1.35 1.35 0 0 1-.66.2Zm1.06-3.88a.89.89 0 0 0-.4.12 3 3 0 0 0-1.22 2.34 1 1 0 0 0 .34.87.62.62 0 0 0 .63-.07 3 3 0 0 0 1.22-2.34 1 1 0 0 0-.34-.87.46.46 0 0 0-.23-.05Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "361.675px 85.6155px"
    },
    id: "eltgtpofwr2mf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.69 87.38a.3.3 0 0 1-.15 0l-1.07-.81a.25.25 0 0 1 0-.34.23.23 0 0 1 .33-.05l1.08.81a.25.25 0 0 1 0 .34.22.22 0 0 1-.19.05Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "363.175px 86.7605px"
    },
    id: "elggcfi8zfhv8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.64 169.22c-3.29 1.89-6 6.53-6 13.17v187.53a4.09 4.09 0 0 0 6.15 3.54l45.21-26.1V161.22l.07-18.22Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "185.355px 258.508px"
    },
    id: "elo0ztylzkkdd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.08 144.67-.08 16.55v185.59l-44.68 25.82a3 3 0 0 1-1.57.43 3.15 3.15 0 0 1-3.14-3.14V182.39c0-6.76 2.84-10.81 5.49-12.34l44-25.38m1-1.67-45.41 26.22c-3.29 1.89-6 6.53-6 13.17v187.53a4.1 4.1 0 0 0 4.1 4.1 4 4 0 0 0 2-.56l45.21-26.1V161.22l.07-18.22Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "185.395px 258.51px"
    },
    id: "elxgvx20hw29o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.63 191.41 23.86-13.77c.84-.48 1.52-.09 1.52.88v2a3.35 3.35 0 0 1-1.52 2.63l-23.86 13.75c-.84.48-1.52.09-1.52-.88v-2a3.35 3.35 0 0 1 1.52-2.61Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "189.56px 187.27px"
    },
    id: "elvn63aa22cqq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.36 196.79v2a3.36 3.36 0 0 1-1.52 2.63l-.61.37c-.84.49-1.52.09-1.52-.88v-2a3.38 3.38 0 0 1 1.52-2.64l.61-.37c.84-.48 1.52-.08 1.52.89Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "169.535px 198.848px"
    },
    id: "eldt9ykh57u8m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.63 202.35 23.86-13.77c.84-.48 1.52-.09 1.52.88v2a3.35 3.35 0 0 1-1.52 2.63l-23.86 13.77c-.84.48-1.52.09-1.52-.88v-2a3.35 3.35 0 0 1 1.52-2.63Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "189.56px 198.22px"
    },
    id: "elusqcc0cizbs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.36 207.73v2a3.35 3.35 0 0 1-1.52 2.63l-.61.37c-.84.49-1.52.1-1.52-.87v-2a3.38 3.38 0 0 1 1.52-2.64l.61-.37c.84-.49 1.52-.09 1.52.88Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "169.535px 209.791px"
    },
    id: "elgvty1akh7l5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.63 213.29 23.86-13.77c.84-.48 1.52-.09 1.52.88v2a3.35 3.35 0 0 1-1.52 2.63l-23.86 13.77c-.84.48-1.52.09-1.52-.88v-2a3.35 3.35 0 0 1 1.52-2.63Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "189.56px 209.16px"
    },
    id: "eltxc42erozo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.36 218.67v2a3.35 3.35 0 0 1-1.52 2.63l-.61.37c-.84.49-1.52.1-1.52-.87v-2a3.38 3.38 0 0 1 1.52-2.64l.61-.37c.84-.48 1.52-.09 1.52.88Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "169.535px 220.733px"
    },
    id: "el0u9qs2eggz2e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.63 249.57 23.86-13.77c.84-.48 1.52-.09 1.52.88v2a3.35 3.35 0 0 1-1.52 2.63l-23.86 13.77c-.84.48-1.52.09-1.52-.88v-2a3.35 3.35 0 0 1 1.52-2.63Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "189.56px 245.44px"
    },
    id: "el34tenvux0hl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.36 255v2a3.35 3.35 0 0 1-1.52 2.63l-.61.37c-.84.49-1.52.1-1.52-.87v-2a3.38 3.38 0 0 1 1.52-2.64l.61-.37c.84-.53 1.52-.12 1.52.88Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "169.535px 257.049px"
    },
    id: "elf8vesvyzqba",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.63 259.26 23.86-13.77c.84-.48 1.52-.09 1.52.88v2a3.35 3.35 0 0 1-1.52 2.63l-23.86 13.77c-.84.48-1.52.09-1.52-.88v-2a3.35 3.35 0 0 1 1.52-2.63Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "189.56px 255.13px"
    },
    id: "elti7bl4zoe1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.36 264.64v2a3.35 3.35 0 0 1-1.52 2.63l-.61.37c-.84.49-1.52.1-1.52-.87v-2a3.38 3.38 0 0 1 1.52-2.64l.61-.37c.84-.48 1.52-.09 1.52.88Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "169.535px 266.703px"
    },
    id: "el0g4jx668i435",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.63 269 23.86-13.77c.84-.48 1.52-.09 1.52.88v2a3.35 3.35 0 0 1-1.52 2.63l-23.86 13.77c-.84.48-1.52.09-1.52-.88v-2a3.35 3.35 0 0 1 1.52-2.63Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "189.56px 264.87px"
    },
    id: "elvjzw5pmd4b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.36 274.33v2a3.35 3.35 0 0 1-1.52 2.63l-.61.37c-.84.49-1.52.1-1.52-.87v-2a3.38 3.38 0 0 1 1.52-2.64l.61-.37c.84-.45 1.52-.09 1.52.88Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "169.535px 276.4px"
    },
    id: "eld9jd6fdh13",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "178.7px 226.32px"
    },
    id: "elqtbsnay09j",
    className: "animable",
    d: "M177.22 224.61v3.42l2.96-3.42h-2.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 223.91c0 .63.45.89 1 .56l19-10.94a2.23 2.23 0 0 0 1-1.75c0-.64-.45-.9-1-.58l-19 11a2.21 2.21 0 0 0-1 1.71Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "192.5px 217.838px"
    },
    id: "el8574y1rgx4x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "178.7px 231.81px"
    },
    id: "elke3uvrypthr",
    className: "animable",
    d: "M177.22 230.1v3.42l2.96-3.42h-2.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 229.4c0 .63.45.88 1 .56L202 219a2.23 2.23 0 0 0 1-1.75c0-.64-.45-.9-1-.58l-19 11a2.21 2.21 0 0 0-1 1.73Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "192.5px 223.316px"
    },
    id: "elvye37vsm1p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "178.7px 237.295px"
    },
    id: "elkwv59isqo7e",
    className: "animable",
    d: "M177.22 235.59V239l2.96-3.41h-2.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 234.89c0 .63.45.88 1 .56l19-10.94a2.25 2.25 0 0 0 1-1.75c0-.64-.45-.9-1-.58l-19 11a2.21 2.21 0 0 0-1 1.71Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "192.5px 228.816px"
    },
    id: "el08sx5rzjl49c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "178.7px 242.785px"
    },
    id: "elg50f28q202f",
    className: "animable",
    d: "M177.22 241.08v3.41l2.96-3.41h-2.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 240.38c0 .63.45.88 1 .56L202 230a2.25 2.25 0 0 0 1-1.75c0-.64-.45-.9-1-.58l-19 11a2.19 2.19 0 0 0-1 1.71Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "192.5px 234.306px"
    },
    id: "elr5jh8lmr77e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.14 51.22a4.32 4.32 0 0 0-4 .51l-203.5 117.49a13.19 13.19 0 0 0-6 10.33v11.57l-7.61-4.47v-11.43a13.16 13.16 0 0 1 5.97-10.31L361.51 47.42c1.7-1 3.23-1 4.33-.35s6.03 3.48 7.3 4.15Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "262.585px 118.87px"
    },
    id: "elbvopxxt0evc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.08 55.13c0-3.76-2.68-5.29-6-3.39L165.64 169.22a13.17 13.17 0 0 0-6 10.33v11.58L375.08 66.78Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "267.36px 121.027px"
    },
    id: "elncyx3yhiki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "263.495px 110.13px"
    },
    className: "animable",
    id: "elysi4mgo8shk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.12 51.73 165.64 169.22a12.34 12.34 0 0 0-4.2 4.42l-7.57-4.38a11.93 11.93 0 0 1 4.13-4.36L361.51 47.42a4.19 4.19 0 0 1 4.33-.36c1.07.66 6 3.47 7.28 4.15a4.31 4.31 0 0 0-4 .52Z",
    style: {
      fill: "#fff",
      transformOrigin: "263.495px 110.13px"
    },
    id: "eloo3wz05auq",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.05 186.68v-11.46a12.25 12.25 0 0 1 1.82-6l7.59 4.37a12 12 0 0 0-1.78 5.92v11.58Z",
    style: {
      opacity: 0.15,
      transformOrigin: "156.755px 180.155px"
    },
    className: "animable",
    id: "el7vz2yve1ac8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.58 67.38c-1.25.72-2.27 2.87-2.27 4.8s1 2.9 2.27 2.18 2.26-2.87 2.26-4.8-1.01-2.9-2.26-2.18Z",
    style: {
      fill: "#37474f",
      transformOrigin: "351.575px 70.87px"
    },
    id: "elv4ktu7xbtfc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.74 62.66c-1.26.72-2.27 2.87-2.27 4.8s1 2.9 2.27 2.18 2.26-2.87 2.26-4.8-1-2.9-2.26-2.18Z",
    style: {
      fill: "#37474f",
      transformOrigin: "359.735px 66.15px"
    },
    id: "elefr9g3csjkm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.89 57.94c-1.25.73-2.26 2.87-2.26 4.8s1 2.9 2.26 2.18 2.27-2.87 2.27-4.8-1.01-2.9-2.27-2.18Z",
    style: {
      fill: "#37474f",
      transformOrigin: "367.895px 61.43px"
    },
    id: "elltde0xtdh9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.5 373.35-6.28-3.63a6.36 6.36 0 0 1-3.12-4.63 8.43 8.43 0 0 1 0-.86V186.66l7.62 4.46v178.8a4.37 4.37 0 0 0 .05.64 1.87 1.87 0 0 0 .08.34.37.37 0 0 0 0 .15 2.32 2.32 0 0 0 .13.37.43.43 0 0 0 0 .05l.21.44c.08.14.18.28.27.41a3.25 3.25 0 0 0 .23.29 4.07 4.07 0 0 0 1.12.9Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "156.95px 280.085px"
    },
    id: "ellmnvh08tev",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-49",
    className: "animable",
    style: {
      transformOrigin: "254.282px 417.95px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder--inject-49",
    className: "animable",
    style: {
      transformOrigin: "254.282px 417.95px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.42 448.7a7.1 7.1 0 0 1-3.5-.83L181 423.1l2.17-1.26-3.07-2.72a.93.93 0 0 1-.3-.8 1 1 0 0 1 .55-.75l19.18-11.08a2.23 2.23 0 0 1 1.69-.14l4.87 1.83a1.1 1.1 0 0 0 .84-.06l36.27-20.94.25.15 42.11 24.31a2.67 2.67 0 0 1 1.34 2.34 2.65 2.65 0 0 1-1.35 2.33l-54.64 31.56a7.16 7.16 0 0 1-3.49.83ZM183 423.1l41.4 23.9a6.75 6.75 0 0 0 6 0l54.65-31.56a1.69 1.69 0 0 0 0-2.93l-41.85-24.16L207.45 409a2.12 2.12 0 0 1-1.68.14l-4.88-1.83a1.1 1.1 0 0 0-.84.07l-19.19 11.07 3.08 2.72a.94.94 0 0 1 .3.8 1.05 1.05 0 0 1-.55.75Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "233.347px 417.941px"
    },
    id: "elq80y1y9ks6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252 448.72a7.19 7.19 0 0 1-3.5-.85l-42.95-24.77 2.18-1.26-3.08-2.72a.93.93 0 0 1-.3-.8 1.05 1.05 0 0 1 .55-.75l19.19-11.08a2.21 2.21 0 0 1 1.68-.14l4.87 1.83a1.13 1.13 0 0 0 .85-.06l36.26-20.94.26.15L300.27 406l-.5.87-32-18.48L232 409a2.12 2.12 0 0 1-1.68.14l-4.87-1.83a1.13 1.13 0 0 0-.85.07l-19.18 11.07 3.07 2.73a.91.91 0 0 1 .3.79 1 1 0 0 1-.55.75l-.66.39L249 447a6.75 6.75 0 0 0 6 0l45.24-26.13.5.88-45.24 26.12a7.19 7.19 0 0 1-3.5.85Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "252.542px 417.95px"
    },
    id: "elpkpny6uoriq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.18 424a25.14 25.14 0 0 1-12.26-2.91c-3.39-2-5.23-4.6-5.19-7.43s1.92-5.37 5.26-7.3c6.77-3.91 17.79-3.91 24.56 0 3.38 1.95 5.23 4.57 5.22 7.37s-1.89 5.42-5.28 7.36a25.44 25.44 0 0 1-12.31 2.91Zm-11.75-3.79c6.46 3.73 17 3.73 23.56 0 3.06-1.75 4.76-4.05 4.77-6.48s-1.66-4.74-4.71-6.5c-6.5-3.75-17.06-3.75-23.56 0-3 1.75-4.71 4-4.75 6.45s1.63 4.77 4.69 6.53Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "311.25px 413.716px"
    },
    id: "el143ufjjss6n9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.84 418a1 1 0 0 1-.5-.13l-11.18-6.46a1 1 0 1 1 1-1.74l11.19 6.45a1 1 0 0 1 .36 1.38 1 1 0 0 1-.87.5Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "311.253px 413.768px"
    },
    id: "elp7m332wbamc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.66 418a1 1 0 0 1-.5-1.88l11.18-6.45a1 1 0 0 1 1.37.36 1 1 0 0 1-.36 1.38l-11.19 6.46a1 1 0 0 1-.5.13Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "311.243px 413.767px"
    },
    id: "el3w2z3l01ef6",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icon--inject-49",
    className: "animable animator-active",
    style: {
      transformOrigin: "122.77px 221.106px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft,1.5s Infinite linear shake",
      animationDelay: "0s,1s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--duplicate-icon--inject-49",
    className: "animable",
    style: {
      transformOrigin: "122.77px 221.106px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-49",
    className: "animable",
    style: {
      transformOrigin: "122.77px 221.106px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.9 143.41c1 .63 5.75 3.33 6.94 3.94a4.13 4.13 0 0 0-3.82.52l-79.39 45.86a12.52 12.52 0 0 0-5.63 9.84v90.36a6.22 6.22 0 0 0 1.68 4.41 4.58 4.58 0 0 0 .42.35c-4.53-3.22-9.27-3.17-9.36-8.89v-90.36a12.61 12.61 0 0 1 5.68-9.84l79.39-45.86a4.11 4.11 0 0 1 4.09-.33Z",
    style: {
      fill: "#263238",
      transformOrigin: "121.79px 220.852px"
    },
    id: "el8jrtzvggleb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Outline--inject-49",
    d: "M168.55 147.09a5.19 5.19 0 0 0-2.54.77l-79.38 45.86a12.58 12.58 0 0 0-5.63 9.84v90.36c0 2.86 1.59 5.3 3.81 5.3a3.86 3.86 0 0 0 1.88-.55l79.48-45.89a12.53 12.53 0 0 0 5.63-9.78l-.11-91.81c0-2.57-1.28-4-3.14-4Z",
    style: {
      fill: "#37474f",
      transformOrigin: "126.4px 223.155px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166 147.86-79.36 45.86a11.63 11.63 0 0 0-4 4.22l-7.22-4.18a11.37 11.37 0 0 1 4-4.15l79.39-45.86a4 4 0 0 1 4.12-.34c1 .63 5.74 3.31 6.93 4a4.1 4.1 0 0 0-3.86.45Z",
    style: {
      fill: "#455a64",
      transformOrigin: "122.64px 170.466px"
    },
    id: "elezxiw63qxp7",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.39 199.43v54c0 2.47 1.73 3.47 3.87 2.24l46.76-27a8.57 8.57 0 0 0 3.88-6.67v-54c0-2.47-1.73-3.47-3.87-2.24l-46.76 27a8.56 8.56 0 0 0-3.88 6.67Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "133.645px 210.715px"
    },
    id: "elbc93yknplt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.4 190.24c0-2.47-1.74-3.47-3.88-2.24l-29.13 16.82v48.6c0 2.47 1.73 3.47 3.87 2.24l29.13-16.82Z",
    style: {
      opacity: 0.3,
      transformOrigin: "122.895px 221.83px"
    },
    className: "animable",
    id: "eleiehhe8dgou"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.86 224.6v54c0 2.47 1.73 3.47 3.87 2.24l46.76-27a8.55 8.55 0 0 0 3.87-6.71v-54c0-2.47-1.73-3.47-3.87-2.24l-46.76 27a8.57 8.57 0 0 0-3.87 6.71Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "119.11px 235.865px"
    },
    id: "elh51r7vupefc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.86 224.6v54c0 2.47 1.73 3.47 3.87 2.24l46.76-27a8.55 8.55 0 0 0 3.87-6.71v-54c0-2.47-1.73-3.47-3.87-2.24l-46.76 27a8.57 8.57 0 0 0-3.87 6.71Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "119.11px 235.865px"
    },
    className: "animable",
    id: "el4lap9nzskjh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.46 231.57v-5.46c0-1-.69-1.39-1.54-.89l-9.36 5.4v-10.8c0-1-.69-1.39-1.55-.9l-4.72 2.73a3.42 3.42 0 0 0-1.55 2.68v10.8l-9.35 5.4a3.41 3.41 0 0 0-1.55 2.68v5.46c0 1 .69 1.38 1.55.89l9.35-5.4V255c0 1 .7 1.39 1.55.89l4.72-2.72a3.43 3.43 0 0 0 1.55-2.69v-10.83l9.36-5.4a3.45 3.45 0 0 0 1.54-2.68Z",
    style: {
      fill: "#fff",
      transformOrigin: "120.65px 237.408px"
    },
    id: "elk909rnns98k",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cursors--inject-49",
    className: "animable",
    style: {
      transformOrigin: "200.112px 292.097px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cursor--inject-49",
    className: "animable",
    style: {
      transformOrigin: "200.112px 292.097px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "207.74px 293.5px"
    },
    id: "el8e4jxoetkmm",
    className: "animable",
    d: "m197.53 266.61-5.53-3.19v56.98l5.53 3.18 10.71-22.48 15.24-8.79-25.95-25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.53 324.06a.54.54 0 0 1-.25-.06l-5.52-3.19a.48.48 0 0 1-.24-.41v-57a.51.51 0 0 1 .24-.42.53.53 0 0 1 .49 0l5.52 3.19.09.07L223.81 292a.49.49 0 0 1 .14.41.46.46 0 0 1-.23.35l-15.11 8.72L198 323.79a.48.48 0 0 1-.29.25.36.36 0 0 1-.18.02Zm-5-3.94 4.82 2.79 10.5-22a.48.48 0 0 1 .19-.21l14.69-8.48-25.5-25.22-4.74-2.74Z",
    style: {
      fill: "#455a64",
      transformOrigin: "207.737px 293.492px"
    },
    id: "elasvrmd8v3te",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "210.505px 295.095px"
    },
    id: "el34kvmxyn2e5",
    className: "animable",
    d: "M197.53 266.61v56.97l10.71-22.48 15.24-8.79-25.95-25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.53 324.06h-.11a.48.48 0 0 1-.38-.47v-57a.48.48 0 0 1 .82-.35L223.81 292a.49.49 0 0 1 .14.41.46.46 0 0 1-.23.35l-15.11 8.72L198 323.79a.47.47 0 0 1-.47.27Zm.48-56.3v53.69l9.8-20.56a.48.48 0 0 1 .19-.21l14.69-8.48Z",
    style: {
      fill: "#455a64",
      transformOrigin: "210.497px 295.08px"
    },
    id: "elwevstaqk8za",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "192.005px 290.21px"
    },
    id: "elfgrgrc6ryzt",
    className: "animable",
    d: "m181.79 263.32-5.52-3.19v56.98l5.52 3.18 10.72-22.48 15.23-8.8-25.95-25.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "194.765px 291.805px"
    },
    id: "elpabsp1ttuai",
    className: "animable",
    d: "M181.79 263.32v56.97l10.72-22.48 15.23-8.8-25.95-25.69z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Duplicate--inject-49",
    className: "animable",
    style: {
      transformOrigin: "295.07px 204.301px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--duplicated-document--inject-49",
    className: "animable",
    style: {
      transformOrigin: "322.073px 204.301px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302 277.57a.43.43 0 0 1-.38-.23.45.45 0 0 1 .16-.61l2.32-1.34a.45.45 0 0 1 .45.78l-2.32 1.34a.46.46 0 0 1-.23.06Zm-3.22-.81a.44.44 0 0 1-.45-.44.2.2 0 0 1 0-.07v-2.64a.45.45 0 0 1 .9 0v2.69a.46.46 0 0 1-.46.46Zm9.42-2.77a.44.44 0 0 1-.22-.83l2.32-1.34a.44.44 0 0 1 .61.16.45.45 0 0 1-.16.61l-2.33 1.34a.46.46 0 0 1-.23.07Zm6.19-3.57a.43.43 0 0 1-.38-.23.45.45 0 0 1 .16-.61l2.33-1.34a.45.45 0 1 1 .44.78l-2.32 1.34a.46.46 0 0 1-.24.06Zm-15.61-.83a.45.45 0 0 1-.45-.45v-2.68a.45.45 0 0 1 .9 0v2.68a.45.45 0 0 1-.46.45Zm21.81-2.75a.47.47 0 0 1-.39-.22.45.45 0 0 1 .17-.61l2.32-1.34a.45.45 0 0 1 .45.77l-2.33 1.34a.43.43 0 0 1-.23.06Zm6.2-3.57a.43.43 0 0 1-.39-.23.45.45 0 0 1 .16-.61l2.33-1.34a.45.45 0 1 1 .44.78l-2.33 1.34a.46.46 0 0 1-.22.06Zm-28-.83a.45.45 0 0 1-.45-.45v-2.68a.45.45 0 0 1 .9 0V262a.45.45 0 0 1-.47.44Zm34.2-2.75a.45.45 0 0 1-.22-.83l2.32-1.34a.45.45 0 0 1 .62.16.45.45 0 0 1-.17.61l-2.32 1.34a.46.46 0 0 1-.22.06Zm6.2-3.57a.46.46 0 0 1-.39-.23.45.45 0 0 1 .17-.61l2.32-1.34a.45.45 0 0 1 .61.17.45.45 0 0 1-.16.61l-2.33 1.34a.43.43 0 0 1-.24.06Zm-40.4-.84a.45.45 0 0 1-.45-.45v-2.68a.45.45 0 1 1 .9 0v2.68a.45.45 0 0 1-.47.45Zm46.6-2.74a.44.44 0 0 1-.39-.22.45.45 0 0 1 .16-.61l2.33-1.34a.43.43 0 0 1 .61.16.45.45 0 0 1-.17.61l-2.32 1.34a.46.46 0 0 1-.24.06Zm6.19-3.57a.43.43 0 0 1-.38-.23.44.44 0 0 1 .16-.61l2.32-1.34a.45.45 0 0 1 .45.78l-2.32 1.34a.46.46 0 0 1-.25.09Zm-52.79-.84a.45.45 0 0 1-.45-.45V245a.45.45 0 0 1 .9 0v2.68a.45.45 0 0 1-.47.45Zm58.44-3.37a.41.41 0 0 1-.21 0 .44.44 0 0 1-.19-.6 4.22 4.22 0 0 0 .5-1.85v-.54a.45.45 0 0 1 .89 0v.54a5 5 0 0 1-.6 2.26.43.43 0 0 1-.41.19ZM298.77 241a.45.45 0 0 1-.45-.44v-2.69a.45.45 0 0 1 .9 0v2.69a.45.45 0 0 1-.45.44Zm59-3.27a.45.45 0 0 1-.45-.45v-2.68a.45.45 0 1 1 .89 0v2.68a.45.45 0 0 1-.45.42Zm-59-3.88a.45.45 0 0 1-.45-.45v-2.68a.45.45 0 0 1 .9 0v2.68a.45.45 0 0 1-.45.42Zm59-3.28a.44.44 0 0 1-.44-.44v-2.69a.45.45 0 0 1 .89 0v2.69a.45.45 0 0 1-.47.41Zm-59-3.87a.45.45 0 0 1-.45-.45v-2.68a.45.45 0 0 1 .9 0v2.68a.45.45 0 0 1-.45.42Zm59-3.28a.45.45 0 0 1-.44-.45v-2.68a.45.45 0 1 1 .89 0v2.68a.45.45 0 0 1-.47.42Zm-59-3.88a.45.45 0 0 1-.45-.45v-2.68a.45.45 0 0 1 .9 0v2.68a.45.45 0 0 1-.45.42Zm59-3.27a.45.45 0 0 1-.44-.45v-2.68a.45.45 0 1 1 .89 0v2.68a.45.45 0 0 1-.47.42Zm-59-3.88a.45.45 0 0 1-.45-.45v-2.68a.45.45 0 0 1 .9 0v2.68a.45.45 0 0 1-.45.42Zm59-3.28a.45.45 0 0 1-.45-.44V206a.45.45 0 0 1 .9 0v2.69a.45.45 0 0 1-.47.39Zm-59-3.88a.45.45 0 0 1-.45-.44v-2.69a.45.45 0 0 1 .9 0v2.69a.45.45 0 0 1-.45.41Zm59-3.27a.45.45 0 0 1-.45-.45v-2.71a.45.45 0 0 1 .9 0v2.68a.45.45 0 0 1-.47.45Zm-59-3.88a.45.45 0 0 1-.45-.45v-2.68a.45.45 0 0 1 .9 0v2.68a.45.45 0 0 1-.45.42Zm59-3.27a.45.45 0 0 1-.45-.45v-2.68a.45.45 0 1 1 .89 0v2.68a.45.45 0 0 1-.46.42Zm-59-3.88a.45.45 0 0 1-.45-.45v-2.68a.45.45 0 0 1 .9 0v2.68a.45.45 0 0 1-.45.42Zm59-3.28a.45.45 0 0 1-.45-.45v-2.68a.45.45 0 1 1 .89 0v2.68a.45.45 0 0 1-.46.42Zm-59-3.88a.45.45 0 0 1-.45-.44v-2.69a.45.45 0 0 1 .9 0v2.69a.45.45 0 0 1-.45.41Zm59-3.27a.45.45 0 0 1-.45-.45v-2.68a.45.45 0 1 1 .89 0V180a.45.45 0 0 1-.46.47Zm-57.95-3.65a.46.46 0 0 1-.27-.09.45.45 0 0 1-.09-.63 4.92 4.92 0 0 1 1.43-1.32l.78-.45a.45.45 0 0 1 .61.16.44.44 0 0 1-.16.61l-.78.45a4 4 0 0 0-1.16 1.08.45.45 0 0 1-.38.16Zm57.94-3.51a.44.44 0 0 1-.44-.44v-2.69a.45.45 0 0 1 .89 0v2.69a.45.45 0 0 1-.47.41Zm-52-.38a.43.43 0 0 1-.39-.23.45.45 0 0 1 .16-.61l2.33-1.34a.45.45 0 0 1 .61.16.46.46 0 0 1-.16.62l-2.31 1.31a.46.46 0 0 1-.25.06Zm6.19-3.58a.45.45 0 0 1-.22-.83l2.32-1.35a.45.45 0 0 1 .45.78l-2.32 1.34a.46.46 0 0 1-.24.03Zm45.8-3.19a.45.45 0 0 1-.45-.45V163a.45.45 0 0 1 .45-.45.45.45 0 0 1 .45.45v2.68a.45.45 0 0 1-.46.48Zm-39.6-.39a.47.47 0 0 1-.39-.22.45.45 0 0 1 .17-.61l2.32-1.34a.44.44 0 0 1 .61.16.45.45 0 0 1-.16.61l-2.33 1.34a.43.43 0 0 1-.23.03Zm6.2-3.57a.43.43 0 0 1-.35-.23.45.45 0 0 1 .16-.61l2.32-1.34a.46.46 0 0 1 .62.16.44.44 0 0 1-.17.61l-2.32 1.35a.46.46 0 0 1-.27.03Zm33.4-3.19a.45.45 0 0 1-.45-.45v-2.68a.45.45 0 0 1 .9 0v2.68a.45.45 0 0 1-.46.41Zm-27.21-.39a.47.47 0 0 1-.39-.22.46.46 0 0 1 .17-.62l2.32-1.34a.45.45 0 0 1 .61.17.45.45 0 0 1-.16.61l-2.33 1.34a.43.43 0 0 1-.23.03Zm6.2-3.58a.44.44 0 0 1-.39-.22.45.45 0 0 1 .16-.61l2.33-1.34a.44.44 0 1 1 .44.77L337 155a.46.46 0 0 1-.27 0Zm21-3.19a.45.45 0 0 1-.45-.44v-2.69a.45.45 0 0 1 .9 0v2.69a.45.45 0 0 1-.45.41Zm-14.82-.38a.46.46 0 0 1-.39-.23.45.45 0 0 1 .17-.61l2.32-1.34a.45.45 0 0 1 .61.16.44.44 0 0 1-.16.61l-2.32 1.35a.49.49 0 0 1-.23.03Zm6.2-3.58a.44.44 0 0 1-.39-.22.46.46 0 0 1 .16-.62l2.33-1.34a.45.45 0 1 1 .44.78l-2.32 1.34a.46.46 0 0 1-.22.03Zm8.46-3.17a.44.44 0 0 1-.41-.28c-.24-.57-.84-.65-1.53-.25l-.1.06a.45.45 0 0 1-.62-.16.44.44 0 0 1 .17-.61l.1-.06a1.83 1.83 0 0 1 2.81.68.45.45 0 0 1-.25.58.33.33 0 0 1-.17.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "328.272px 210.31px"
    },
    id: "elsfckh2i9pa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.77 203.86a.43.43 0 0 1-.22-.06l-2.33-1.34a.45.45 0 0 1-.16-.61.45.45 0 0 1 .61-.17L299 203a.46.46 0 0 1 .17.62.44.44 0 0 1-.4.24Zm-6.2-3.58a.46.46 0 0 1-.22-.06l-2.35-1.34a.45.45 0 0 1 .44-.78l2.33 1.35a.45.45 0 0 1 .16.61.44.44 0 0 1-.36.22Zm-6.19-3.58a.46.46 0 0 1-.23-.06l-2.32-1.34a.45.45 0 0 1-.17-.61.45.45 0 0 1 .62-.16l2.32 1.34a.45.45 0 0 1-.22.83Zm-6.2-3.58a.38.38 0 0 1-.23-.06l-2.32-1.34a.44.44 0 0 1-.16-.61.45.45 0 0 1 .61-.16l2.32 1.34a.45.45 0 0 1-.22.83Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "288.317px 197.375px"
    },
    id: "el2sxwmrkvsts",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357 132.67c5.17-3 9.36-.56 9.36 5.41s-4.19 13.24-9.36 16.22-9.37.57-9.37-5.4 4.18-13.24 9.37-16.23Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "356.995px 143.482px"
    },
    id: "el5esixlkqa1s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.8 156a5.13 5.13 0 0 1-2.63-.68c-1.89-1.09-2.93-3.36-2.93-6.39 0-6.09 4.29-13.52 9.56-16.56 2.62-1.52 5.11-1.75 7-.66s2.94 3.37 2.94 6.4c0 6.09-4.29 13.51-9.56 16.56a9 9 0 0 1-4.38 1.33Zm8.37-24.2a8.18 8.18 0 0 0-4 1.23c-5.06 2.92-9.18 10.05-9.18 15.9 0 2.74.91 4.78 2.55 5.73s3.87.72 6.25-.66c5.06-2.92 9.17-10.05 9.17-15.89 0-2.75-.91-4.78-2.55-5.73a4.41 4.41 0 0 0-2.24-.61Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "356.99px 143.517px"
    },
    id: "el6v6eb6v770a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 141.12v-2.21c0-.4-.28-.56-.63-.36l-3.8 2.19v-4.39c0-.4-.28-.56-.62-.36L356 137.1a1.39 1.39 0 0 0-.63 1.09v4.38l-3.8 2.19a1.39 1.39 0 0 0-.63 1.09v2.22c0 .4.28.56.63.36l3.8-2.19v4.38c0 .4.28.57.63.37l1.92-1.11a1.4 1.4 0 0 0 .62-1.09v-4.38l3.8-2.2a1.39 1.39 0 0 0 .66-1.09Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "356.97px 143.489px"
    },
    id: "elst2a2pyby89",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Document--inject-49",
    className: "animable",
    style: {
      transformOrigin: "332.583px 212.362px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.53 166.66V236a3.28 3.28 0 0 1-1.49 2.58l-50.12 28.94a1 1 0 0 1-1.05.1l-2.8-1.61a1 1 0 0 1-.43-1v-83.72a3.28 3.28 0 0 1 1.48-2.58L343.76 157Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "332.578px 212.362px"
    },
    id: "elnk0l1h1ln9k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.23 182.8-5.23-2.88a3.08 3.08 0 0 0-.38 1.37V265a1 1 0 0 0 .43 1l2.8 1.61a1 1 0 0 0 1.05-.1l1.31-.75Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "307.418px 223.817px"
    },
    id: "ell5nrjdasl2p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.53 166.66V236a3.31 3.31 0 0 1-1.49 2.58l-50.12 28.94c-.82.47-1.49.09-1.49-.86v-83.75a3.29 3.29 0 0 1 1.49-2.58l29.25-16.9 8.39-4.84Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "333.98px 213.156px"
    },
    id: "el0hqi5xsvoyfd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.56 159.44 13.23 7.65V236a2.55 2.55 0 0 1-1.12 1.94l-50.12 28.94a.7.7 0 0 1-.3.1s-.07-.11-.07-.32v-83.75a2.56 2.56 0 0 1 1.11-1.94l29.25-16.9 8-4.63m0-.85-8.39 4.84-29.25 16.9a3.29 3.29 0 0 0-1.49 2.58v83.71c0 .67.34 1.06.83 1.06a1.31 1.31 0 0 0 .66-.2l50.1-28.94a3.31 3.31 0 0 0 1.49-2.58v-69.3l-14-8.07Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "333.95px 213.135px"
    },
    id: "elqkchcn906zg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.2 167.21c.54 0 .92.43.92 1.18v59a3.66 3.66 0 0 1-1.65 2.86l-37 21.34a1.41 1.41 0 0 1-.74.23c-.54 0-.91-.43-.91-1.18v-59a3.66 3.66 0 0 1 1.65-2.86l25-14.43 12-6.91a1.48 1.48 0 0 1 .73-.22m0-.69a2.19 2.19 0 0 0-1.08.32l-12 6.9-25 14.44a4.34 4.34 0 0 0-2 3.45v59a1.68 1.68 0 0 0 1.6 1.87 2.2 2.2 0 0 0 1.09-.32l37-21.34a4.36 4.36 0 0 0 2-3.46v-59a1.67 1.67 0 0 0-1.6-1.87Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "333.966px 209.515px"
    },
    id: "elm4035zdzyvn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.56 173v-14.41l14 8.07-12.48 7.2c-.85.48-1.52.14-1.52-.86Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "353.56px 166.332px"
    },
    id: "elli61d8gty",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m321.39 211.11 25.19-14.69a4.16 4.16 0 0 0 1.94-3.21c0-1.16-.87-1.6-1.94-1l-25.2 14.68a4.15 4.15 0 0 0-1.93 3.22c0 1.18.87 1.62 1.94 1Zm25.19-9.6-25.2 14.69a4.15 4.15 0 0 0-1.93 3.22c0 1.15.87 1.59 1.94 1l25.19-14.69a4.16 4.16 0 0 0 1.94-3.22c0-1.18-.87-1.62-1.94-1Zm0 9.29-25.2 14.69a4.12 4.12 0 0 0-1.93 3.21c0 1.16.87 1.6 1.94 1l25.19-14.7a4.13 4.13 0 0 0 1.94-3.21c0-1.17-.87-1.61-1.94-.99Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "333.985px 210.955px"
    },
    id: "elbdn41vbtf58",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m321.39 211.11 25.19-14.69a4.16 4.16 0 0 0 1.94-3.21c0-1.16-.87-1.6-1.94-1l-25.2 14.68a4.15 4.15 0 0 0-1.93 3.22c0 1.18.87 1.62 1.94 1Zm25.19-9.6-25.2 14.69a4.15 4.15 0 0 0-1.93 3.22c0 1.15.87 1.59 1.94 1l25.19-14.69a4.16 4.16 0 0 0 1.94-3.22c0-1.18-.87-1.62-1.94-1Zm0 9.29-25.2 14.69a4.12 4.12 0 0 0-1.93 3.21c0 1.16.87 1.6 1.94 1l25.19-14.7a4.13 4.13 0 0 0 1.94-3.21c0-1.17-.87-1.61-1.94-.99Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "333.985px 210.955px"
    },
    className: "animable",
    id: "elg3gfycgfyq"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--document--inject-49",
    className: "animable",
    style: {
      transformOrigin: "251.38px 215.884px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.32 170.19v69.3a3.31 3.31 0 0 1-1.49 2.58L227.71 271a1.06 1.06 0 0 1-1.06.1l-2.79-1.61a1 1 0 0 1-.43-1v-83.67a3.3 3.3 0 0 1 1.48-2.58l37.64-21.73Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "251.368px 215.854px"
    },
    id: "elp1i09eqqhd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229 186.33-5.2-2.88a3 3 0 0 0-.39 1.37v83.72a1.05 1.05 0 0 0 .44 1l2.79 1.61a1 1 0 0 0 1.06-.1l1.3-.75Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "226.2px 227.354px"
    },
    id: "ele87ewd7xupt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.32 170.19v69.3a3.31 3.31 0 0 1-1.49 2.58L227.71 271c-.82.47-1.49.09-1.49-.86v-83.7a3.29 3.29 0 0 1 1.49-2.58L257 167l8.38-4.84Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "252.77px 216.681px"
    },
    id: "elhue6wbrilv7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.34 163 13.24 7.65v68.87a2.58 2.58 0 0 1-1.12 1.94l-50.12 28.94a.69.69 0 0 1-.31.1.53.53 0 0 1-.07-.32v-83.74a2.55 2.55 0 0 1 1.12-1.94l29.25-16.9 8-4.63m0-.85L257 167l-29.25 16.9a3.29 3.29 0 0 0-1.49 2.58v83.71c0 .67.34 1.06.83 1.06a1.31 1.31 0 0 0 .66-.2l50.12-28.94a3.31 3.31 0 0 0 1.49-2.58v-69.3l-14-8.07Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "252.81px 216.685px"
    },
    id: "elo9c5ix4o0ib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 170.74c.54 0 .91.43.91 1.18v59a3.66 3.66 0 0 1-1.65 2.86l-37 21.34a1.46 1.46 0 0 1-.74.23c-.54 0-.91-.43-.91-1.18v-59a3.66 3.66 0 0 1 1.65-2.86l25-14.43 12-6.91a1.55 1.55 0 0 1 .74-.22m0-.69a2.16 2.16 0 0 0-1.08.32l-12 6.9-25 14.44a4.35 4.35 0 0 0-2 3.45v59a1.68 1.68 0 0 0 1.6 1.87 2.16 2.16 0 0 0 1.08-.32l37-21.34a4.36 4.36 0 0 0 2-3.46v-59a1.68 1.68 0 0 0-1.6-1.87Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "252.76px 213.045px"
    },
    id: "el7wmjmnoja0s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.35 176.53v-14.41l14 8.07-12.48 7.2c-.87.48-1.52.09-1.52-.86Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "272.35px 169.858px"
    },
    id: "elkoojj0t4rgj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.17 214.64 25.2-14.64a4.16 4.16 0 0 0 1.94-3.21c0-1.16-.87-1.6-1.94-1l-25.2 14.68a4.13 4.13 0 0 0-1.93 3.22c0 1.13.86 1.57 1.93.95Zm25.2-9.6-25.2 14.69a4.13 4.13 0 0 0-1.93 3.22c0 1.15.86 1.59 1.93 1l25.2-14.69a4.16 4.16 0 0 0 1.94-3.22c0-1.18-.87-1.61-1.94-1.04Zm0 9.29L240.17 229a4.09 4.09 0 0 0-1.93 3.21c0 1.16.86 1.6 1.93 1l25.2-14.69a4.13 4.13 0 0 0 1.94-3.21c0-1.16-.87-1.6-1.94-.98Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "252.775px 214.5px"
    },
    id: "eladntda7lws5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.17 214.64 25.2-14.64a4.16 4.16 0 0 0 1.94-3.21c0-1.16-.87-1.6-1.94-1l-25.2 14.68a4.13 4.13 0 0 0-1.93 3.22c0 1.13.86 1.57 1.93.95Zm25.2-9.6-25.2 14.69a4.13 4.13 0 0 0-1.93 3.22c0 1.15.86 1.59 1.93 1l25.2-14.69a4.16 4.16 0 0 0 1.94-3.22c0-1.18-.87-1.61-1.94-1.04Zm0 9.29L240.17 229a4.09 4.09 0 0 0-1.93 3.21c0 1.16.86 1.6 1.93 1l25.2-14.69a4.13 4.13 0 0 0 1.94-3.21c0-1.16-.87-1.6-1.94-.98Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "252.775px 214.5px"
    },
    className: "animable",
    id: "el80yprjttdru"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-49",
    className: "animable",
    style: {
      transformOrigin: "385.098px 290.651px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-49",
    className: "animable",
    style: {
      transformOrigin: "385.098px 290.651px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-49",
    className: "animable",
    style: {
      transformOrigin: "414.803px 338.263px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.52 399.32c.08 4.34.42 10.65 0 12.45s-7.65 3.56-13.31 3.82-12.47-.59-12.88 3.41 3.14 6.67 5.74 7.87c4.41 2.05 9.33 1.6 13.66 1s6.64-.18 11.21.94 7.15.43 9.1-.55c2.9-1.45 2.13-6.4 1.11-9.62s-.91-6.17-.53-10.64 1.66-11 1.66-11Z",
    style: {
      fill: "#ffbda7",
      transformOrigin: "383.289px 413.193px"
    },
    id: "el0arkfcod33ir",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.15 418.56s0 1.37-3 2-7.88.46-11.33.69c-5.17.33-9.09.92-15 0-5.2-.82-5-4.94-.32-5.6-5.24.09-10.81-.27-11.18 3.31-.41 4 3.14 6.67 5.74 7.87 4.41 2.05 9.33 1.6 13.66 1s6.64-.18 11.21.94 7.15.43 9.1-.55c2.91-1.49 2.14-6.44 1.12-9.66Z",
    style: {
      fill: "#455a64",
      transformOrigin: "383.177px 422.498px"
    },
    id: "elxbpj0mnr7x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.26 388.55c2.43 3.52 6.43 10.18 7 11.83s1.06 7.86 0 9.69c-1.52 1.11-3.9 1.75-5.93 2.75-2.94 1.45-3.57 3.86-1.65 5.7 2.67 2.57 7 2.87 9.6 2.72 3.8-.58 4.06-4.83 4.6-8.6s-.07-11.16 2.79-15.71 7.91-5 8.57-3.46c-.31-2.29-1.58-2.35-4.31-3.9s-5.12-1.5-6.63-5.09c-1.8-4.25-3.43-9.32-3.43-9.32Z",
    style: {
      fill: "#ffbda7",
      transformOrigin: "453.911px 398.216px"
    },
    id: "elyclw07lolb8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.6 421.31c2.72.45 4.64.45 9.47-1.92 4.18-2.05 5.24-2.92 5.88-4.05 1-1.8-.08-6.24.79-10.06a39.89 39.89 0 0 1 2.76-7.81c.95-2.32.88-3.32.73-4-.33-1.45-3.28-1.63-6.09 0s-4.63 4.74-5.56 12.15.5 15.51-7.98 15.69Z",
    style: {
      fill: "#263238",
      transformOrigin: "457.459px 406.928px"
    },
    id: "elnqiesup3uz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.23 393.47c-.32-2.29-1.11-2.63-3.84-4.17-1-.58-2-1-2.95-1.46-2.65-.5-6.82 1.58-7 7.14s.74 12.61-.93 15.22c-1.43 2.23-3.77 2.08-3.23-.13-3.76 1.38-5.05 1.4-7.17 2.56-2.44 1.34-3.26 4.83-1 6.23a14.53 14.53 0 0 0 10.19 2.38c3.8-.58 4.06-4.83 4.6-8.6s-.07-11.16 2.79-15.71 7.88-4.93 8.54-3.46Z",
    style: {
      fill: "#455a64",
      transformOrigin: "453.506px 404.574px"
    },
    id: "el38jp0ovtnl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 390.76s-13.79-20.25-21.15-33.37c-5.45-9.7-5.94-11.58-7.28-17.93-2.87-13.63-3.54-16.83-3.54-16.83l-4.28 27.54c.69 3 2.07 8.91 2.12 12.39a134.66 134.66 0 0 1-1.65 20.3 215.53 215.53 0 0 1-4.19 22.5c-1.07.74-4.18.89-6.88.8a31.74 31.74 0 0 1-7.74-1.45s-2.25-32.45-2.77-41.38c-.63-10.71-.85-14.92-1.19-20.8-.53-9.37-1.8-22.93-1.44-40.15.72-34.24 8.35-49.87 8.35-49.87l38.64-5.37c3.21 11.54 9.88 12.88 10.58 28.63.16 3.57-1.73 10.67-1.8 16.21-.2 18-1.81 46.26-1.81 46.26 4.24 3.91 7.35 7.45 10.28 16.52 1.78 5.51 5.73 19.47 7.4 25.13-4.89 0-11.73 8.66-11.65 10.87Z",
    style: {
      fill: "#455a64",
      transformOrigin: "418.798px 326.662px"
    },
    id: "el6tu7v1lojme",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.9 272.25 1-.16c.9 6.21 2.38 13.25 3.19 13.8 1.42 1 6.68 1.76 7.86 1.46s2.23-1.26 4.33-4.11c1.47-2 1.31-3.25 1-6-.13-1-.28-2.18-.37-3.64l1-.07c.09 1.42.23 2.57.36 3.58.35 2.75.56 4.4-1.17 6.75-2.27 3.08-3.41 4.14-4.91 4.5a2.83 2.83 0 0 1-.66.08c-2.08.1-6.6-.73-8-1.68-1.53-1.06-3.17-11.37-3.63-14.51Z",
    style: {
      fill: "#37474f",
      transformOrigin: "413.205px 280.269px"
    },
    id: "el2ju22v8ogeu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.08 271.34 1 .29c-2.93 10.51-2.29 20.14 2.95 23.07 1-7.1 2.3-14.44 4.15-22.29l1 .24c-6 25.29-6.68 45.21-5.91 69.14.58 18.24 1.74 49.58 2.28 64.13l-1.05-.18c-.54-14.63-1.69-45.77-2.27-63.91-.52-16.21-.35-30.58 1.65-46-6-3.07-6.94-13.22-3.8-24.49Z",
    style: {
      fill: "#37474f",
      transformOrigin: "391.75px 338.63px"
    },
    id: "el5zte9ruuof8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.12 280.77a5.73 5.73 0 0 1-2.27 1.34c-1.63.07-4.33-2.25-5.1-4a11.82 11.82 0 0 1-.65-3.18 29.15 29.15 0 0 0-.86-4.7l1-.3a30.24 30.24 0 0 1 .9 4.87 10.79 10.79 0 0 0 .57 2.88c.65 1.48 3 3.42 4.1 3.37a8.32 8.32 0 0 0 2.59-2c-.1.48-.2 1.19-.28 1.72Z",
    style: {
      fill: "#37474f",
      transformOrigin: "435.82px 276.021px"
    },
    id: "elh775com5abl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.22 385.31c.24-.28.49-.55.74-.82-6.6-11.51-20.77-36.68-22-42.79-1.62-7.82-4.41-34.05-4.53-48.16h-1c.11 14.16 2.91 40.51 4.54 48.37 1.27 6.4 15.7 31.98 22.25 43.4Z",
    style: {
      fill: "#37474f",
      transformOrigin: "433.195px 339.425px"
    },
    id: "els5nczygbls",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426 268.14c2.62 4.17 4.21 11.49.83 19.51l-.95-.41c3.22-7.65 1.72-14.59-.76-18.53Z",
    style: {
      fill: "#37474f",
      transformOrigin: "426.936px 277.895px"
    },
    id: "elcnjza52r0y9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411 322.63 4.2-28.87s10.87-1.52 12.37-11.72c.26 6-2.15 11.25-8.9 14l-5.4 26.65 1.27 16.72Z",
    style: {
      fill: "#37474f",
      transformOrigin: "419.294px 310.725px"
    },
    id: "elxa7syr9vyz",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-49",
    className: "animable",
    style: {
      transformOrigin: "379.369px 213.016px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.26 200.5c7 1.67 10.85 3.62 13.74 13.18 2.74 9 7.33 24.33 8.54 30.81.58 3.16.85 6.17-3.54 8-9.92 4.2-19.49 7.14-19.49 7.14l-3.87-11.71 10.6-5.3-2.64-8.54Z",
    style: {
      fill: "#ffbda7",
      transformOrigin: "442.25px 230.065px"
    },
    id: "elonuqtl79n7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.24 242.64a10.15 10.15 0 0 0 4.38 4.78c-2.59.31-5.11-2.39-5.77-4.09Z",
    style: {
      fill: "#f0997a",
      transformOrigin: "440.735px 245.042px"
    },
    id: "eliq7g297fpbi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.76 200.42c3.14.57 7.44 1.23 10.58 6s8.24 21.4 8.24 21.4-2.49 3.1-9 4.84-9.25.26-9.25.26L429.47 217Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "441.025px 216.964px"
    },
    id: "elolmvgmvl4iq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.76 200.42c3.14.57 7.44 1.23 10.58 6s8.24 21.4 8.24 21.4-2.49 3.1-9 4.84-9.25.26-9.25.26L429.47 217Z",
    style: {
      opacity: 0.2,
      transformOrigin: "441.025px 216.964px"
    },
    className: "animable",
    id: "elqsgmp4ru928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.1 165.49c-1.23-1.64-1.05-4.1-.17-6s2.58-3.75 7.29-5.78c5.6-2.41 20.88-4 26.74 6.22.87 1.53-15.1 28.56-14.79 34.31-3.5-4.26-15-19.15-15-19.15-2.87-1.47-4.59-2.67-5-5.51a6.88 6.88 0 0 1 .93-4.09Z",
    style: {
      fill: "#263238",
      transformOrigin: "415.569px 173.077px"
    },
    id: "eld2eigm1w4n7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.77 173.42s-4.46 6.25-4.06 6.81a20.52 20.52 0 0 0 2.83 2.17Z",
    style: {
      fill: "#f0997a",
      transformOrigin: "398.727px 177.91px"
    },
    id: "el16at7q1vps3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.59 161.85c-2.77 1.08-5.25 3-6.5 8.81-.33 1.52.72 3.71 0 5.72-3 8.6-.7 16.11.89 17.85 1.07 1.17 7.06 2.08 10.28 1.42 4-.82 12.9-4.08 17.44-10 5.33-6.93 7.15-16.63 2.06-20.93-7.12-6.03-21.21-4.02-24.17-2.87Z",
    style: {
      fill: "#ffbda7",
      transformOrigin: "416.2px 178.227px"
    },
    id: "elch4n43nmuyq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.79 190.45.5 8.74c4.86 2.83-5.18 6.53-15.83 2l-.77-7.88Z",
    style: {
      fill: "#ffbda7",
      transformOrigin: "418.62px 196.882px"
    },
    id: "el009x9kx0ql84d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.05 196.88c.19 2 .39 5-2.74 5.88-2.95.78-7.71 1.27-12.35 3 0 0 16.72 2.64 25.5 1.19s10.3-7.09 10.3-7.09c-3.16-.43-4.48-1-4.6-3Z",
    style: {
      fill: "#ffbda7",
      transformOrigin: "412.86px 202.122px"
    },
    id: "elqo9etj7es0h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.31 194.47c1.35.88 4.4 1.67 8.64 1.39l-.19-2.19a23.19 23.19 0 0 1-4.09.91 14.65 14.65 0 0 1-4.36-.11Z",
    style: {
      fill: "#f0997a",
      transformOrigin: "405.63px 194.794px"
    },
    id: "elpo69i051xxp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.4 164.72c-.42 3.8 1.89 5.18 3.54 6.05a8.18 8.18 0 0 0-1 4.45c.24 2 .87 3.6 2.73 4.38 1.13.47 1.51 0 2-.9.68-1.27 1.56-3.22 4.34-2.64 3.19.67 3.7 5.58 1.59 8.62a4.72 4.72 0 0 1-3.8 2.19 3 3 0 0 1-2.11-1.19s-.09 4.24 5.17 7.14c0 0 5.27 3.48 11 2.21a105.7 105.7 0 0 0 7.78-8.3c6.55-8.16 7.92-23.65-2-27.19-.47-.16-8.61-2.22-13.14-1.57-13.92 2.03-16.03 6.09-16.1 6.75Z",
    style: {
      fill: "#263238",
      transformOrigin: "420.584px 176.576px"
    },
    id: "els8u2oumcj1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433 160c1.56 0 6.29 2.41 6.27 12.91 0 7.1-1.71 16.59-4 21-6.08 6.7-23.68 8-31.46 5.17 5-2.31 5.94-8.57 5.92-13.42 2.3 3.48 6.51 4.31 11.61 1.75S433 160 433 160Z",
    style: {
      fill: "#263238",
      transformOrigin: "421.54px 180.243px"
    },
    id: "elo4zpsppdhte",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.08 209.19c-1.46-7.09-5.3-8.63-7-8.94l-4.42-.77c0 .84.6 2.85-7.24 3.83-5 .63-13.75-.66-13.75-.66a85.22 85.22 0 0 0-9.92 2.22c-5.09 1.45-7.77 7.39-11.1 15.24-2.62 6.2-1.64 12.51 3.05 17.13a94.87 94.87 0 0 1-.28 11.6 110.28 110.28 0 0 0-3.52 22.94s3 2.8 26.83 2.27c18.46-.42 27-8.67 27-8.67-.53-2.75-2.46-8.66-5.95-17.84.42-8.98 9.45-23 6.3-38.35Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "412.985px 236.798px"
    },
    id: "elh4ctysrot6p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.05 227.81s-26.24-5.22-27.74-6.3c-1.27-.92-1.68-2.43-2.32-3.78a17.49 17.49 0 0 0-2.9-4.2c-.74-.84-1.64-1.56-2.34-2.43s-.91-1.82-1.54-2.64-1.47-.23-1.87.56a4.75 4.75 0 0 0 .09 3.57c.19.5.36 1 .56 1.51a7.27 7.27 0 0 1 .55 1.4 1.14 1.14 0 0 1-.06.75c-.28.47-1.17.16-1.56 0a21 21 0 0 1-7.06-4.69c-.86-.87-1.54-1.85-2.46-2.66a11.34 11.34 0 0 0-2.83-1.88 4 4 0 0 0-2.23-.4c-1.13.42.13 2.23.43 2.84a4.17 4.17 0 0 1 .52 2.19 3.42 3.42 0 0 0 .78 2.51 6.85 6.85 0 0 1 1.44 2.55 8.68 8.68 0 0 1 0 1 5 5 0 0 0 1.2 2.8 4 4 0 0 1 1.06 2.63c.23 2.22 2.55 3.85 4.28 4.91a29.31 29.31 0 0 0 6.38 2.82c1.2.39 2.36.88 3.56 1.24s2.18.53 3.23.93c2.49.95 21.81 8.31 29.51 10.44 3.8 1.05 4.82 2 10.17-.79 9.63-5 19.06-8.47 24.6-11.86 7.59-4.65 10.81-7.25 11.85-12.2 2.39-11.48-5.17-13.6-5.17-13.6-2.77.71-4.2 1.35-12.63 6.23-9 5.22-27.5 16.55-27.5 16.55Z",
    style: {
      fill: "#ffbda7",
      transformOrigin: "352.847px 224.778px"
    },
    id: "elx52m6yi9shl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.18 205.05c-4.65.53-7.07 1.81-12.23 5.06S371 219.05 371 219.05a25.72 25.72 0 0 0 6.14 13.95c4.14 4.73 7.5 4.34 7.5 4.34s13.87-10.2 16.67-14.13 4.88-15.71-4.13-18.16Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "387.354px 221.199px"
    },
    id: "elqod8mtrc51o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.18 205.05c-4.65.53-7.07 1.81-12.23 5.06S371 219.05 371 219.05a25.72 25.72 0 0 0 6.14 13.95c4.14 4.73 7.5 4.34 7.5 4.34s13.87-10.2 16.67-14.13 4.88-15.71-4.13-18.16Z",
    style: {
      opacity: 0.2,
      transformOrigin: "387.354px 221.199px"
    },
    className: "animable",
    id: "elctah3bldmq7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-49",
    className: "animable",
    style: {
      transformOrigin: "419.145px 110.026px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "419.145px 110.026px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "419.145px 110.026px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m420.46 134.44-2.62-4.91 2.11-6.07v-3.71l-6.44 3.71v3.72l2.77 4.79a.33.33 0 0 0 .19.16Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "416.985px 127.095px"
    },
    id: "ellhmucbpgp39",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m420.46 134.44-2.62-4.91 2.11-6.07v-3.71l-6.44 3.71v3.72l2.77 4.79a.33.33 0 0 0 .19.16Z",
    style: {
      opacity: 0.2,
      transformOrigin: "416.985px 127.095px"
    },
    className: "animable",
    id: "elxjw81ssafm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.82 90.22a4.24 4.24 0 0 0-1.93-3.34l-1.57-.88a4.3 4.3 0 0 0-3.86 0l-24.08 13.9a4.26 4.26 0 0 0-1.93 3.34v26.5a4.24 4.24 0 0 0 1.93 3.34l1.62.92a4.24 4.24 0 0 0 3.86 0l7.74-4.47 2.76 4.78a.42.42 0 0 0 .75-.07l2.89-8.44 9.92-5.74a4.24 4.24 0 0 0 1.93-3.34Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "419.15px 110.026px"
    },
    id: "elafxoyo7wjht",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.67 108.36v-3c0-.54-.39-.76-.86-.49l-5.16 3v-6c0-.54-.38-.77-.85-.49l-2.61 1.5a1.89 1.89 0 0 0-.85 1.48v6l-5.16 3a1.86 1.86 0 0 0-.86 1.48v3c0 .54.38.76.86.49l5.16-3v6c0 .55.38.77.85.49l2.61-1.5a1.89 1.89 0 0 0 .85-1.48v-6l5.16-3a1.89 1.89 0 0 0 .86-1.48Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "421.495px 111.601px"
    },
    id: "elv0gan7c7yt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.45 129.74a4.24 4.24 0 0 0 1.93 3.34l1.62.92a4.29 4.29 0 0 0 3.53.16c-.91.34-1.6-.17-1.6-1.27v-26.5a3.89 3.89 0 0 1 .56-1.9l-5.49-3.15a4 4 0 0 0-.56 1.9Z",
    style: {
      opacity: 0.2,
      transformOrigin: "405.985px 117.902px"
    },
    className: "animable",
    id: "el87conr353wl"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.76 89.67c-.23-.82-1-1.08-1.87-.57L409.8 103a3.76 3.76 0 0 0-1.35 1.44l-5.45-3.09a3.79 3.79 0 0 1 1.36-1.44L428.46 86a4.3 4.3 0 0 1 3.86 0l1.57.91a4.25 4.25 0 0 1 1.87 2.76Z",
    style: {
      fill: "#fff",
      opacity: 0.3,
      transformOrigin: "419.38px 94.9913px"
    },
    className: "animable",
    id: "el3ks98xtnqml"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTreeCreated);
export default __webpack_public_path__ + "static/media/noTreeCreated.c938998081cb62e2f940272a17a12dc3.svg";
export { ForwardRef as ReactComponent };